
import { Chip } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../../common/EnhancedTableHead';
import LinkRouter from '../../../common/LinkRouter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    latestChip: {
      marginLeft: 16
    }
  })
);

interface Props {
  workflow: any;
}

const headRows: HeadRow[] = [
  { id: 'version', disablePadding: true, label: 'Version' },
  { id: 'owner', disablePadding: false, label: 'User' },
  { id: 'timestamp', disablePadding: true, label: 'Created' }
];

function WorkflowRevisionsTab(props: Props) {
  const { workflow } = props;
  const classes = useStyles({});
  
  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('timestamp');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  };

  const sortedRows = sortRows(workflow.Versions || [], getSorting(order, orderBy));
  const latestVersion = Math.trunc(parseFloat(workflow.LastModified) * 100);

  return (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={row.timestamp}>
              <TableCell>
                <LinkRouter variant="body1" to={`/families/${workflow.Family}/workflows/${workflow.GUID}?version=${row.timestamp}`}>{row.timestamp}</LinkRouter>
                {row.timestamp === latestVersion && <Chip className={classes.latestChip} label="Latest" size="small" variant="outlined" />}
              </TableCell>
              <TableCell>{row.owner}</TableCell>
              <TableCell>
                {moment(row.timestamp * 10).fromNow()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={workflow.Versions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default WorkflowRevisionsTab;
